/**
 * Host-based routing helpers.
 *
 * The app is a single bundle that serves BOTH the public storefront and the
 * internal POS. Which experience is the default depends on the hostname:
 *
 *   - radgameshop.com / www.radgameshop.com  -> storefront mounted at the root
 *                                               (clean URLs, no `/store` prefix).
 *                                               The POS is NOT reachable here.
 *   - pos.radgameshop.com                     -> POS at the root (login + tools),
 *                                               storefront still under `/store`.
 *   - preview / localhost / anything else     -> unchanged: POS at the root,
 *                                               storefront under `/store`.
 *
 * `storeUrl()` returns the correct link target for storefront routes in every
 * context, so internal links work whether the storefront lives at `/` or
 * `/store`.
 */
const HOSTNAME = (typeof window !== 'undefined' && window.location.hostname) || '';

export const isStorefrontHost =
  HOSTNAME === 'radgameshop.com' || HOSTNAME === 'www.radgameshop.com';

export const isPosHost = HOSTNAME === 'pos.radgameshop.com';

// Base path the storefront is mounted at: '' on the public apex, '/store' else.
export const STORE_BASE = isStorefrontHost ? '' : '/store';

export const storeUrl = (path = '') => {
  if (!path || path === '/') return STORE_BASE || '/';
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${STORE_BASE}${p}`;
};

// The POS (admin) app is always namespaced under /pos on every host, so its
// routes are radgameshop.com/pos, /pos/inventory, /pos/settings, etc. The root
// paths (/inventory, /orders, …) are reserved for the storefront.
export const POS_BASE = '/pos';

export const posUrl = (path = '') => {
  if (!path || path === '/') return POS_BASE;
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${POS_BASE}${p}`;
};
